import { useTranslation } from 'react-i18next';
import { Icon } from '@mui/material';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import clsx from 'clsx';

import CommonDropzone from '../../../../components/common-dropzone/CommonDropzone';

import scss from './UploadCard.module.scss';

function UploadCard({ onShowUploadModal }) {
  const { t } = useTranslation('id8');

  const handleDrop = (files) => {
    onShowUploadModal(files);
  };

  return (
    <div className={scss.wrapper}>
      <CommonDropzone onDrop={handleDrop}>
        {({ isDragAccept }) => (
          <div className={scss.uploaderBlock}>
            <Icon
              component={AddPhotoAlternateOutlinedIcon}
              baseClassName={clsx(scss.uploaderIcon, isDragAccept && scss.uploaderIconFocused)}
            />
            <span>{t('uploadYourAdHere')}</span>
          </div>
        )}
      </CommonDropzone>
    </div>
  );
}

export default UploadCard;
